import http from '@/services/Http/http'
import auth from '@/services/Auth'
import axios from 'axios'
import { TechnicalException } from '@/services/ErrorHandler'

export default {
  getCoverageClaimApiService () {
    return auth.hasCoverageAccess() ? http.Coverage : http.Claim
  },
  getServiceForCompaniesV3 () {
    if (auth.hasCoverageAccess()) {
      return http.Coverage
    } else if (auth.hasClaimAccess()) {
      return http.Claim
    } else if (auth.hasIceAccess()) {
      return http.Envelope
    } else if (auth.hasTokenAccess()) {
      return http.Api
    } else {
      return undefined
    }
  },
  async getProductSetting () {
    let params = {
      version: '3'
    }
    try {
      let response = await axios.get(`settings/product`, { params })
      return response.data
    } catch (e) {
      throw new TechnicalException(e)
    }
  }
}
